

















import { Component, Prop, Vue, Watch } from 'vue-property-decorator'
import { useGenerateCodeCommand, useSendCodeCommand } from '@/app/asyncStates/identityConfirmationStates'
import { apiKey } from '@/api/configuration/config'
import { useAsyncStateErrorHandler } from '@/infranstructure/useAsyncStateErrorHandler'
import { useSignCommand } from '@/app/asyncStates/processStates'
import { useAsyncState } from '@/infranstructure/useAsyncState'
import PhoneLikeConfirmationForm from './phoneLikeConfirmation/PhoneLikeConfirmationForm.vue'
import { otpPhoneLikeVerificationResponse } from '@/models/digitalIdentities/otp/models'
import { phoneLikeIdentities, contactTypeViews } from '@/models/digitalIdentities'

type UploadTransactionPayload = { id: string; uid: string }

@Component({
  components: {
    PhoneLikeConfirmationForm,
  },
})
export default class PhonelikeConfirmation extends Vue {
  @Prop({ type: String, required: true }) readonly identityType!: typeof phoneLikeIdentities[number]
  @Prop({ type: String, required: true }) readonly payload!: string
  @Prop({ type: String, required: true }) public id!: string
  @Prop({ type: String, required: true }) public uid!: string

  private verify = useSendCodeCommand(apiKey, useAsyncStateErrorHandler)
  private sign: ReturnType<typeof useSignCommand> | null = null
  private generateCode = useGenerateCodeCommand(apiKey, useAsyncStateErrorHandler)
  private uploadTransaction = useAsyncState<unknown, [UploadTransactionPayload]>(
    (params) => this.$store.dispatch('uploadTransaction', params),
    useAsyncStateErrorHandler,
    { immediate: false },
  )
  private otpVerification:any = null
  private code = ''

  created() {
    // Дополнительная гарантия
    if (!this.otpVerification) {
      this.setDefaultState()
    }
    if (this.id && this.uid) this.sign = useSignCommand(this.id, this.uid)
  }

  @Watch('id')
  @Watch('uid')
  public onIdOrUidChanged() {
    this.sign = useSignCommand(this.id, this.uid)
  }

  @Watch('payload')
  public onPayloadChanged() {
    if (!this.otpVerification) {
      this.setDefaultState()
    }
  }

  public setDefaultState() {
    this.code = ''
    this.otpVerification = otpPhoneLikeVerificationResponse(this.payload)
  }

  public async onVerifyCode(code: string) {
    const command = {
      data: this.payload,
      code: code,
    }
    await this.verify.execute(0, command)
    if (this.verify.state.isValid && !!this.sign) {
      await this.sign.execute()
      await this.uploadTransaction.execute(0, { id: this.id, uid: this.uid })
      this.$router.push(`/confirmation/${this.id}/${this.uid}`)
    } else {
      this.$notify({ title: 'Ошибка', message: 'Введен неверный код подтверждения', color: '#FF5252' })
    }
  }

  public onConfirmationCodeInput(value: string) {
    this.code = value
  }

  public async onResendCode() {
    const command = {
      data: this.payload,
      type: this.identityType,
    }
    const response = await this.generateCode.execute(0, command)
    this.$router.replace({ name: 'phone-like-confirmation', params: { payload: response.data }, query: { id: this.id, uid: this.uid, identityType: this.identityType } })
  }
}
